module.exports = __webpack_public_path__ + "img/invision.2183e873.png";